import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3" }

import { InputRow, Combobox } from '@/components/ui/form';
    import { useEconomicAccountData } from '@/composables/useEconomicAccountData';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
import { computed } from 'vue';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectEconomicForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    

    const { accounts } = useEconomicAccountData(companyId.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "contra_account_id",
      label: "viia.accounts.attach"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          modelValue: _ctx.form.contra_account_id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.contra_account_id) = $event)),
          options: _unref(accounts),
          translate: false,
          placeholder: _ctx.$t('viia.accounts.attach'),
          loading: false,
          "label-by": "number_and_name",
          "value-by": "accountNumber"
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})